module.exports = __webpack_public_path__ + "static/media/logo.ab1ea791.svg";